import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import HelpIcon from '@mui/icons-material/Help';
import useGeneralDialog from '../../hooks/dialogs/useGeneralDialog';
import { ShippingDialogContent } from './shipping-dialog/ShippingDialogContent';

export const ProductShippingStatus: React.FC<{ availableQty: number }> = (
    props
) => {
    const { availableQty } = props;
    const { t } = useTranslation('product', {
        keyPrefix: 'PRODUCT.SHIPPING',
    });
    const generalDialog = useGeneralDialog();

    const openShippingInfoDialog = () => {
        generalDialog.showDialog({
            title: t('LABEL'),
            component: ShippingDialogContent,
        });
    };

    return (
        <Box sx={{ paddingTop: '20px' }} onClick={openShippingInfoDialog}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    paddingBottom: '10px',
                    cursor: 'pointer',
                }}
            >
                {t('LABEL')}
                <HelpIcon />
            </Box>
            <Box>{availableQty > 0 ? t('AVAILABLE') : t('PREORDER')}</Box>
        </Box>
    );
};
